import { render } from "./Spinner.vue?vue&type=template&id=0d366a6b"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=0d366a6b&lang=css"
script.render = render

export default script